var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-container"},_vm._l((_vm.dots),function(dot){return _c('div',{key:dot,staticClass:"dot",class:_vm.stylesFor(dot)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }